<template>
  <div>
    <van-empty
      class="custom-image"
      :image="require('@/assets/images/squirrelCup/2024/cupTwo/empty.png')"
      :description="word"
    />
  </div>
</template>

<script>
import { Empty } from "vant";
export default {
  props: {
    word: {
      type: String,
      default: "暂无此信息",
    },
  },
  data() {
    return {};
  },
  components: {
    [Empty.name]: Empty,
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
/deep/ .van-empty {
  font-weight: bold;
  img {
    object-fit: contain;
    font-size: 28px;
    color: #000000;
  }
}
</style>
